<template>
  <div class="page-loader" id="container" v-if="!isloaded">
  <svg viewBox="0 0 100 100">
    <defs>
      <filter id="shadow">
        <feDropShadow dx="0" dy="0" stdDeviation="1.5"
                      flood-color="#fc6767"/>
      </filter>
    </defs>
    <circle id="spinner" style="fill:transparent;stroke:#2f7eaf;stroke-width: 7px;stroke-linecap: round;" cx="50" cy="50" r="45"/>
  </svg>
</div>
</template>

<script>
export default {
  data: ()=>{
    return{
      isloaded: false,
    }
  },
  mounted(){
    document.onreadystatechange = () => {
      if (document.readyState=="complete"){
        this.isloaded = true;
      }
    }
  }
}
</script>

<style scoped>
.page-loader {
  display:flex;
  justify-content:center;
  align-items:center;
  position: fixed;
  top: 0;
  left: 0;
  width:100vw;
  height:100vh;
  background:#333;
  opacity: .5;
  /*transform: translate(-50%,-50%);*/
  z-index:999;
}

#container {
  width:100vw;
  height:100vh;
}
svg{
  width:200px;
  height:200px;
}

@keyframes animation {
  0% {
    stroke-dasharray: 1 98;
    stroke-dashoffset: -105;
  }
  50% {
    stroke-dasharray: 80 10;
    stroke-dashoffset: -160;
  }
  100% {
    stroke-dasharray: 1 98;
    stroke-dashoffset: -300;
  }
}

#spinner {
  transform-origin: center;
  animation-name: animation;
  animation-duration: 1.2s;
  animation-timing-function: cubic-bezier;
  animation-iteration-count: infinite;
}
</style>